import classnames from "classnames";
import React from "react";
import ChevronDownIcon from "../../icons/ChevronDownIcon";
import { SanityRawContent } from "../../model/common";
import BlockContent from "../BlockContent/BlockContent";
import Text from "../Text/Text";
import styles from "./ExpandableList.module.scss";

interface ExpandableListProps {
  className?: string;
  sections: ExpandableListSection[];
}

export interface ExpandableListSection {
  title: string;
  id: string;
  content: SanityRawContent;
}

const ExpandableList = ({ className, sections }: ExpandableListProps) => {
  return (
    <div className={classnames(className, styles.root)}>
      {sections.map((section: ExpandableListSection, key: number) => (
        <details key={key}>
          <summary>
            {/*Wrapper needed for Safari 13/14*/}
            <div className={styles.summaryContent}>
              <Text variant="h4">{section.title}</Text>
              <ChevronDownIcon
                aria-hidden
                className={classnames(styles.chevronIcon)}
              />
            </div>
          </summary>
          <div className={styles.content}>
            <BlockContent
              content={section.content}
              className={styles.expandableListBlockContent}
              cap="3/4"
            />
          </div>
        </details>
      ))}
    </div>
  );
};

export default ExpandableList;
